module.exports = __webpack_public_path__ + "static/media/ga.1902ae2c.svg";